//3rd Party Components
import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MetaTags from 'react-meta-tags';

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import Heading from '../components/CASA/Heading';
import Container from '../components/CASA/Container';

//Actions and Selectors
import { getUserHomePage, UserMustSubmitIndividualARNApplication, UserMustVerifyPOI } from '../components/Portal/Utilities';
import { getSystemSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getAddressDetailsIndividual, FETCH_ADDRESSDETAILSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AddressDetailsIndividualActions';
import { getUserDetailsSelector } from '../PortalStore/Selectors/UserDetailsSelectors';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';

export const ProfileDetailsIndPage = () => {
    let history = useHistory();
    let dispatch = useDispatch();

    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");

    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let userdetails = useSelector(state => state.userdetails);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let addressdetailsIndividual = useSelector(state => state.addressdetailsIndividual);

    let sysPWD = useSelector(state => getSystemSelector(state, "Portal - Password Change Policy"));

    let urlB2C = useSelector(state => getUrlSelector(state, "Portal - B2C URL"));
    let urlAEM = useSelector(state => getUrlSelector(state, "Portal - AEM URL"));
    let urlUpdateUser = useSelector(state => getUrlSelector(state, "Portal - AEM Update User Details URL"));

    let fullname = useSelector(state => getUserDetailsSelector(state, "fullname"));
    let arn = useSelector(state => getUserDetailsSelector(state, "casa_arn"));
    let email = useSelector(state => getUserDetailsSelector(state, "emailaddress1"));

    let pageAlert = useSelector(state => state.pageAlert);

    if (!pageLoaded && pageAlert.level !== "") {
        dispatch(addPageAlert({ level: "", title: "", message: "" }));
    }

    useEffect(() => {
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;

        axios.all([
            dispatch(getAddressDetailsIndividual(webappurl, accessToken))
        ])
            .then(axios.spread((addrdetailsres) => {
                if (addrdetailsres.type === FETCH_ADDRESSDETAILSINDIVIDUAL_SUCCESS) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("PDI.1");
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: PDI.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setPageLoadedError(true);
                setPageLoadedErrorMessage("PDI.1");
                setPageLoaded(true);

                dispatch(addPageAlert({ level: "error", title: "System error PDI.1" }));
            });
        
    }, []);

    const showSpinner = () => {
        if (!pageLoadedError) {
            return (<CASASpinner message="Working. Please wait....." />)
        }
        else {
            return null;
        }
    }

    const showPostal = (postal) => {
        if (postal)
            return (<span><br /><strong>Postal: </strong><br />{postal}</span>);
        else
            return null;
    }

    const showResidential = (residential) => {
        if (residential)
            return (<span><br />{residential}</span>);
        else
            return null;
    }

    const navigateAEMUpdateDetails = () => {
        const userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);

        const crumbs = [
            {
                link: userHomePage,
                text: 'myCASA'
            },
            {
                link: "/forms/profileind?standalone=" + standalone,
                text: 'Profile'
            }
        ];
        const params = {
            'breadcrumbs': crumbs
        };

        if (participants.hasParticipants) {
            params.showProfileSelector = 1;
        }
        const aemnav = urlAEM + urlUpdateUser + "?" + encodeURIComponent(btoa(JSON.stringify(params)));

        return aemnav;
    }

    const showStreet = (street1, street2, street3, street4, street5) => {
        return (
            <div>
                {street1 !== '' ? { street1 } : ""}
                {street1 !== '' ? <br /> : ""}
                {street2 !== '' ? { street2 } : ""}
                {street2 !== '' ? <br /> : ""}
                {street3 !== '' ? { street3 } : ""}
                {street3 !== '' ? <br /> : ""}
                {street4 !== '' ? { street4 } : ""}
                {street4 !== '' ? <br /> : ""}
                {street5 !== '' ? { street5 } : ""}
                {street5 !== '' ? <br /> : ""}
            </div>
        )
    }

    const tail = '/oauth2/v2.0/authorize?p=' + sysPWD + '&client_id={{settings["Authentication/OpenIdConnect/B2C/ClientId"]}}&nonce=defaultNonce&' +
        'redirect_uri={{settings["Authentication/OpenIdConnect/B2C/RedirectUri"]}}&scope=openid&response_type=id_token&prompt=login';
    const navigateB2C = urlB2C + tail;

    let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);

    if (UserMustSubmitIndividualARNApplication(userHomePage) || UserMustVerifyPOI(userHomePage)) {
        history.push(userHomePage);
    }
    else {
        const showItems = true;

        const items = [
            {
                text: 'myCASA',
                link: '/forms/dashind?standalone=' + B2CSettings.items.standalone
            },
            {
                text: 'Profile'
            }
        ];

        if (!pageLoaded) {
            return (
                <Fragment>
                    <MetaTags>
                        <title>Individual Profile Details</title>
                    </MetaTags>

                    <div className="row">
                        <div className="col-sm-12">
                            <Heading
                                text="Profile"
                                breadcrumbs={items}
                                showcrumbs={showItems}
                                showback={false} />
                        </div>
                    </div>

                    <Container show={true}>
                    </Container>

                    {showSpinner()}

                </Fragment>)

        }
        else {
            let details = addressdetailsIndividual.items.value[0];
            let residential = '';
            let residential1 = '';
            let residential2 = '';
            let residential3 = '';
            let residential4 = '';
            let residential5 = '';
            let postal = '';
            let postal1 = '';
            let postal2 = '';
            let postal3 = '';
            let postal4 = '';
            let postal5 = '';
            let mobile = '';

            residential1 = (details.address1_line3 || "") + (details.casa_address1_extraline || "") + (details.address1_line1 || "") + (details.address1_line2 || "");

            residential1 = residential1.trim();
            residential2 = (details.casa_address1_building || "").trim();
            residential3 = (details.address1_city || "").trim();

            residential4 = (details.address1_stateorprovince || "").trim() + (details.address1_postalcode || "");
            residential4 = residential4.trim();

            residential5 = (details.address1_country || "").trim();

            //if (residential1 !== '') residential1 = <div>residential1<br /></div>;
            //if (residential2 !== '') residential2 = residential2 + '<br>';
            //if (residential3 !== '') residential3 = residential3 + '<br>';
            //if (residential4 !== '') residential4 = residential4 + '<br>';
            //if (residential5 !== '') residential5 = residential5 + '<br>';

            //residential = residential1 + residential2 + residential3 + residential4 + residential5;

            postal1 = (details.address2_line3 || "").trim() + (details.casa_address2_extraline || "").trim() + (details.address2_line1 || "").trim() + (details.address2_line2 || "").trim();
            postal1 = postal1.trim();

            postal2 = (details.casa_address2_building || "").trim();

            postal3 = (details.address2_city || "").trim();

            postal4 = (details.address2_stateorprovince || "").trim() + (details.address2_postalcode || "");
            postal4 = (postal4 || "").trim();

            postal5 = (details.address2_country || "").trim();
            let postalSize = postal1.length + postal2.length + postal3.length + postal4.length + postal5.length;

            if (postal1 !== '') postal1 = <div>postal1<br /></div>;
            if (postal2 !== '') postal2 = postal2 + '<br>';
            if (postal3 !== '') postal3 = postal3 + '<br>';
            if (postal4 !== '') postal4 = postal4 + '<br>';
            if (postal5 !== '') postal5 = postal5 + '<br>';

            postal = postal1 + postal2 + postal3 + postal4 + postal5;

            mobile = (details.mobilephone || "").trim();

            //if (residential === postal) {
            //    postal = <div>Same as Residential.<br /></div>;
            //}

            //let tmpResidential = residential.replace("<br>", "").trim();

            return (
                <Fragment>
                    <MetaTags>
                        <title>Individual Profile Details</title>
                    </MetaTags>

                    <div className="row">
                        <div className="col-sm-12">
                            <Heading
                                text="Profile"
                                breadcrumbs={items}
                                showcrumbs={showItems}
                                showback={false} />
                        </div>
                    </div>

                    <br />
                    <div className="row">
                        <div className="col-sm-12">
                            <h2>Account settings</h2>
                            <a href={navigateB2C}>Update Password</a>
                            <br />

                            <h2>Personal details</h2>
                            <strong>Name: </strong>{fullname}
                            <br />
                            <strong>ARN: </strong>{arn}
                            <br />
                            <h2>Contact details</h2>
                            <strong>Email: </strong>{email}

                            <a id="emailupdate" href="/changeemail')">Update email address</a>

                            <br />
                            <strong>Mobile: </strong> {mobile}
                            <br />

                            <h2>Address details</h2>
                            <strong>Residential:</strong>

                            {showStreet(residential1, residential2, residential3, residential4, residential5)}
                            

                            <br />
                            <p>
                                <a href={navigateAEMUpdateDetails()}>Update your details</a>
                            </p>

                        </div>
                    </div>

                    <br />
                </Fragment>
            );
        }
    }

}
